 ONE.foo = function (bar) {
   return baz(bar);
 };